import React from "react";
import { Link, Icon } from "@telia/teddy";

import { FWA_LABELS, FWA_LINKS } from "../../../../../../constants";
import { trackFunnelEvent } from "../../../../google-analytics";

const getStepFromPath = (path: string) => {
    return Math.max((FWA_LINKS as readonly string[]).indexOf(path), 0) + 1;
};

interface BackLinkProps {
    href: string;
    path: string;
    text: string;
}

const BackLink: React.FC<BackLinkProps> = ({ path, href, text }) => {
    const handleGoTo = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        try {
            const step = getStepFromPath(path);
            await trackFunnelEvent({
                step: `${step}`,
                label: FWA_LABELS[step - 1],
                name: "FWA - Trådløst Bredbånd",
                isUIEvent: true,
                uiEventName: "tilbake",
            });
        } finally {
            if (href) {
                window.location.assign(href);
            } else {
                window.history.back();
            }
        }
    };

    return (
        <Link variant="standalone" href="#" onClick={handleGoTo}>
            <Icon name="arrow-left" />
            {text}
        </Link>
    );
};

export default BackLink;
